export default __webpack_public_path__ + "static/upper2_2-472eaf0d717399c2a92fbf7a7342453d.jpg";